const o = "alpha", t = "beta", s = "delta", n = "epsilon", c = "omega", A = "pi", a = "sigma", e = [o, t, s, n, c, A, a];
export {
  o as ALPHA,
  t as BETA,
  s as DELTA,
  n as EPSILON,
  c as OMEGA,
  A as PI,
  a as SIGMA,
  e as TEXT_VARIANTS
};
